module.exports = __webpack_public_path__ + "img/delete.44e56c80.svg";